import classNames from 'classnames';

export default function ImageRoundButton({ alt, color, src, onClick, title, className, lucide }) {

    if (!lucide) {
        return (
            <img className={classNames(className, color, "p-1 size-10 rounded-full hover:opacity-70 cursor-pointer")}
                src={src}
                alt={alt}
                title={title || ""}
                onClick={onClick}
            ></img>
        )
    } else {
        return (
            <div className={classNames(className, color, "p-1 size-10 rounded-full hover:opacity-70 cursor-pointer flex justify-center items-center")}
                title={title || ""}
                onClick={onClick}
            >
                {lucide}
            </div>

        )
    }


}